/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Work_0_DescInputs */

const en_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order and catalog pipelines that keep storefront chats stocked and synced, without manual exports.`)
};

const ar_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطوط الطلبات والكتالوج تبقي محادثات المتجر مليئة ومتزامنة، دون تصدير يدوي.`)
};

const bn_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অর্ডার ও ক্যাটালগ পাইপলাইন স্টোর চ্যাট পূর্ণ আর সিঙ্ক রাখে, হাতে এক্সপোর্ট ছাড়াই।`)
};

const de_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestell- und Katalog-Pipelines, die Shop-Chats bestückt und synchronisiert halten, ohne manuelle Exporte.`)
};

const es_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines de pedidos y catálogo que mantienen los chats de la tienda abastecidos y sincronizados, sin exportaciones manuales.`)
};

const fr_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des pipelines de commandes et de catalogue qui gardent les chats de boutique achalandés et synchronisés, sans exports manuels.`)
};

const pt_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines de pedidos e catálogo que mantêm os chats da loja abastecidos e sincronizados, sem exportações manuais.`)
};

const zh_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单和目录管道让店铺聊天不断货、保持同步，不用手动导出。`)
};

const tr_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağaza sohbetlerini dolu ve senkron tutan sipariş ve katalog hatları, manuel aktarma yok.`)
};

const ru_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказные и каталожные пайплайны держат чаты магазина полными и синхронными, без ручных выгрузок.`)
};

const pl_svc_messaging_bots_work_0_desc = /** @type {(inputs: Svc_Messaging_Bots_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potoki zamówień i katalogu trzymają czaty sklepu pełne i zsynchronizowane, bez ręcznych eksportów.`)
};

/**
* | output |
* | --- |
* | "Order and catalog pipelines that keep storefront chats stocked and synced, without manual exports." |
*
* @param {Svc_Messaging_Bots_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_work_0_desc = /** @type {((inputs?: Svc_Messaging_Bots_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "de") return de_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "es") return es_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_work_0_desc(inputs)
	return en_svc_messaging_bots_work_0_desc(inputs)
});
export { svc_messaging_bots_work_0_desc as "svc_messaging-bots_work_0_desc" }